import InvoiceScreen from './index';
import DetailScreen from './detail';
import CreateScreen from './create';
import UpdateScreen from './update';

const routes = [
  {
    path: '/invoice',
    component: InvoiceScreen,
    action: ['read_only', 'manage'],
    service: ['nvo.tms.invoice'],
  },
  {
    path: '/invoice/create',
    component: CreateScreen,
    action: ['manage'],
    service: ['nvo.tms.invoice'],
  },
  {
    path: '/invoice/:id',
    component: DetailScreen,
    action: ['read_only', 'manage'],
    service: ['nvo.tms.invoice'],
  },
  {
    path: '/invoice/update/:id',
    component: UpdateScreen,
    action: ['manage'],
    service: ['nvo.tms.invoice'],
  },
];

export default routes;
